import {
  MoreVertical,
  ChevronLast,
  ChevronFirst,
  LayoutDashboard,
  Phone,
  MessageSquare,
  Send,
  BotMessageSquare,
  Bot,
  Hotel,
  Banknote,
  Users,
  Search,
  ChevronDown,
  Settings,
} from "lucide-react";
import { useContext, createContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { t, getLang } from "../i18n"; // <-- import i18n

const SidebarContext = createContext();

export default function Sidebar({ children, open = false, onToggle }) {
  const expanded = open;
  const location = useLocation();
  const lang = getLang();
  const isRTL = lang === "ar";

  return (
    <aside
      className={`fixed top-0 ${
        isRTL ? "right-0" : "left-0"
      } transition-all duration-300 overflow-scroll z-30 ${
        expanded ? "w-64" : "w-16"
      }`}
      dir={isRTL ? "rtl" : "ltr"}
    >
      <nav
        className={` flex flex-col h-screen overflow-scroll bg-white  ${
          isRTL ? "rounded-r-2xl" : "rounded-l-2xl"
        }`}
      >
        <div className="flex justify-center  items-center p-4">
          <img
            src={"../../logo.png"}
            className={`overflow-hidden transition-all ${
              expanded ? "w-16" : "w-0"
            }`}
            alt=""
          />
          {/* <button
              onClick={onToggle}
              className="p-1.5 rounded-lg bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              {!expanded ? <ChevronFirst /> : <ChevronLast />}
            </button> */}
        </div>
        {/* input with search */}
        <div className="p-5 relative ">
          <input
            type="text"
            placeholder="البحث"
            className="w-full text-gray-900 py-3 pl-10 pr-10 rounded-xl border border-gray-200 bg-gray-50 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-200"
          />
          <Search
            className="absolute right-8 top-1/2 -translate-y-1/2 text-gray-400"
            size={20}
          />
        </div>
        <h1 className="px-5 pb-2 font-bold text-[#1D2035]">الرئيسيه</h1>
        <SidebarContext.Provider value={{ expanded }}>
          <SidebarItem
            icon={<LayoutDashboard size={20} />}
            text={t("dashboard")}
            to="/admin/"
            active={location.pathname === "/admin/"}
          />
          <SidebarItem
            icon={<LayoutDashboard size={20} />}
            text={" ادارة القوانين"}
            to="/admin/laws"
            active={location.pathname === "admin/laws"}
          />

          <SidebarItem
            icon={<Users size={20} />}
            text={t("users")}
            to="/admin/users"
            active={location.pathname === "/admin/users"}
          />
          <SidebarItem
            icon={<Users size={20} />}
            text={"الاستشارات القانونية"}
            to="/admin/legal-consultations"
            active={location.pathname === "/admin/legal-consultations"}
          />
          <SidebarItem
            icon={<MessageSquare size={20} />}
            text={"الدعم الفني"}
            to="/admin/support"
            active={location.pathname === "/admin/support"}
          />
          <SidebarItem
            icon={<MessageSquare size={20} />}
            text={"الاشعارات"}
            to="/admin/notifications"
            active={location.pathname === "/admin/notifications"}
          />
          <SidebarItem
            icon={<MessageSquare size={20} />}
            text={"ادارة المدونة"}
            to="/admin/blog"
            active={location.pathname === "/admin/blog"}
          />
          <SidebarItem
            icon={<MessageSquare size={20} />}
            text={"إدارة المجتمع"}
            to="/admin/community"
            active={location.pathname === "/admin/community"}
          />

          <SidebarItem
            icon={<Bot size={20} />}
            text={"إدارة التقارير"}
            to="/admin/reports"
            active={location.pathname === "/admin/reports"}
          />

          <div className="mx-5 my-4 border-t border-gray-200 border-dashed" />
          <h1 className="px-5 pb-2 font-bold text-[#1D2035]">النظام</h1>
          <SidebarItem
            icon={<Settings size={20} />}
            text={"الإعدادات"}
            to="/admin/settings"
            active={location.pathname === "/admin/settings"}
          />
          {/* <ul className="flex-1 px-3 dark:text-gray-100">{children}</ul> */}
        </SidebarContext.Provider>

        <div className="border-t dark:border-gray-700 flex p-3 mt-auto">
          <img
            src={
              "https://ui-avatars.com/api/?background=2446ed&name=" +
              localStorage.getItem("user")
            }
            alt=""
            className="w-10 h-10 rounded-full"
          />
          <div
            className={`
              flex justify-between items-center w-full
              overflow-hidden transition-all ${
                expanded ? "mx-3" : "w-0"
              } dark:text-gray-100"
          `}
          >
            <div className="leading-4">
              <h4 className="font-semibold dark:text-gray-100 flex items-center gap-2">
                <span className="text-xs text-gray-500">المسؤول</span>
              </h4>
              <span className="text-sm text-gray-900 dark:text-gray-100 block">
                {localStorage.getItem("user")}
              </span>
            </div>
            <ChevronDown size={18} className="text-gray-400" />
          </div>
        </div>
      </nav>
    </aside>
  );
}

export function SidebarItem({ icon, text, active, alert, to }) {
  const { expanded } = useContext(SidebarContext);

  return (
    <Link to={to || "#"} className="block my-1">
      <li
        className={`
          relative flex items-center 
          font-medium rounded-lg cursor-pointer
          transition-colors group
          ${
            active
              ? "bg-rose-50 text-[#580405]"
              : "hover:bg-gray-50 text-[#1D2035]"
          }
          ${expanded ? "py-2 px-3" : "p-2 justify-center"}
        `}
      >
        {/* Icon square */}
        <div
          className={`flex items-center justify-center w-9 h-9 rounded-md border shadow-sm transition-colors ${
            active
              ? "bg-[var(--Primary-Primary)] text-white border-[var(--Primary-Primary)]"
              : "bg-white text-gray-700 border-gray-200"
          }`}
        >
          {icon}
        </div>
        <span
          className={`overflow-hidden transition-all ${
            expanded ? "w-52 mx-3" : "w-0"
          }`}
        >
          {text}
        </span>

        {/* Numeric alert badge */}
        {typeof alert === "number" && (
          <div className="absolute -left-2 top-1/2 -translate-y-1/2">
            <div className="bg-red-500 text-white text-xs font-bold rounded-md w-5 h-5 flex items-center justify-center">
              {alert}
            </div>
          </div>
        )}

        {/* Tooltip on collapse */}
        {!expanded && (
          <div
            className={`
              absolute left-full rounded-md px-2 py-1 ml-6
              bg-indigo-100 text-indigo-800 text-sm
              invisible opacity-20 -translate-x-3 transition-all
              group-hover:visible group-hover:opacity-100 group-hover:translate-x-0
              whitespace-nowrap
            `}
          >
            {text}
          </div>
        )}
      </li>
    </Link>
  );
}
<ul>
  {/* ...existing links... */}
  <li></li>
  {/* ...existing links... */}
</ul>;
